import { AppState } from '../../types'
import { ResourcesState, ResourceSelected } from './model'
import { TimePickerState } from '../TimePickerNavbar/model'

/* Get all monitoring resources*/
const getAllResources = (state: AppState): ResourcesState => state.monitoring.resources

export const getResourceSelected = (state: AppState): ResourceSelected => state.monitoring.resources.resourceSelected

export const getSelectedResourceType = (state: AppState) => getResourceSelected(state).resourceType

export const getResources = (state: AppState) =>
  getAllResources(state).applications.data.map(d => d.id).concat(getAllResources(state).apis.data.map(a => a.id.toString()))

const getAll = (state: AppState): TimePickerState => state.monitoring.timePicker

export const getTimeValue = (state: AppState) => getAll(state).time

export const getApplications = (state: AppState) => getAllResources(state).applications.data

export const getApis = (state: AppState) => getAllResources(state).apis.data

export const getEnvironments = (state: AppState) => getAllResources(state).environments.data

export const isLandingPageHidden = (state: AppState) => getAllResources(state).isLandingPageHidden

export const getDashboardType = (state: AppState) => getAllResources(state).dashboardType

export const getResourceTypeSelected = (state: AppState): string => getAllResources(state).resourceTypeSelected

// get selected
export const getSelectedEnvironmentId = (state: AppState) => getAllResources(state).environments.selected

export const getSelectedEnvironmentInfo = (state: AppState) => {
  const selectedEnvironmentId = getSelectedEnvironmentId(state)
  if (selectedEnvironmentId)
    return getAllResources(state).environments.data.find(env => env.id === selectedEnvironmentId)
  return ''
}

export const getSelectedResource = (state: AppState) => getSelectedApplicationId(state)

export const getSelectedApiId = (state: AppState) => getAllResources(state).apis.apiSelected

export const getSelectedAPIVersion = (state: AppState) => getAllResources(state).apis.selected

export const getSelectedResourceDetails = (state: AppState) => getAllResources(state).resourceDetail.data

export const getSelectedApplicationId = (state: AppState) => getAllResources(state).applications.selected

export const getSelectedTargetId = (state: AppState) => getAllResources(state).applications.selectedTargetId

export const getSelectedServerName = (state: AppState, appId: string) => {
  const result = getAllResources(state).resourceSelected
  return result ? result.serverName : undefined
}

// isLoading
export const isLoadingApis = (state: AppState) => getAllResources(state).apis.loading

export const isLoadingApplications = (state: AppState) => getAllResources(state).applications.loading

export const isLoadingApplicationDetails = (state: AppState) => getAllResources(state).resourceDetail.loading

export const isLoadingEnvironments = (state: AppState) => getAllResources(state).environments.loading

export const isOpenedModal = (state: AppState) => getAllResources(state).openedModal

export const getLastSelection = (state: AppState) => getAllResources(state).resourceSelected
